import React from 'react';
import { useLocation } from 'react-router-dom';

import { Button, Typography, Box } from '@mui/material';

import { useAuth } from '../../context/AuthContext';

const Login = () => {

  const { login } = useAuth();
  const location = useLocation();

  console.debug('Login component rendered, current location:', location, location.state?.from);

  const handleLogin = () => {

    // If the user was redirected to login from a protected route, save that route for post-login redirect
    const from = location.state?.from;
    if (from) {
      console.debug('Setting the post-login redirect state to:', from);
      const redirectState = {
        pathname: from.pathname,
        search: from.search,
        hash: from.hash,
      };

      sessionStorage.setItem(
        "post_login_redirect",
        JSON.stringify(redirectState)
      );
    }

    login();
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        background: '#adacac',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: '#fff',
          fontWeight: 'bold',
          textShadow: '2px 4px 6px rgba(0, 0, 0, 0.5)',  // Adds text shadow
          mb: 4,
        }}
      >
        Shop Assist Pro
      </Typography>

      <Button
        variant="contained"
        color="primary"
        size="large"
        sx={{
          padding: '10px 20px',
        }}
        onClick={handleLogin}
      >
        Login
      </Button>
    </Box>
  );
};

export default Login;
